import styled from 'styled-components';
import { FloatingArrow } from '@floating-ui/react';

export const TooltipWrapper = styled.div`
  width: 100%;
`;

export const TooltipBox = styled.div`
  background-color: ${({ theme }) => theme.palette.system['black-80']};
  color: ${({ theme }) => theme.palette.primary.background};
  width: 325px;
  padding: 10px 15px;
  font-size: 14px;
  border-radius: 14px;
  z-index: 10201;
`;

export const Arrow = styled(FloatingArrow)`
  fill: ${({ theme }) => theme.palette.system['black-80']};
`;
